$(document).ready(function () {
	$(document).on("change", "#modal-course-prolongate [name=months]", function () {
		let $modal = $(this).closest('#modal-course-prolongate');
		let $payCredits = $modal.find('[name=pay_method]').filter(function () {
			return $(this).val().indexOf('credit') === 0;
		});

		let credit = Boolean(parseInt($(this).data('credit')));

		if (credit) {
			$payCredits.removeAttr('disabled');
		} else {
			$payCredits.attr('disabled', 'disabled');
		}

		let $payChecked = $modal.find('[name=pay_method]:checked');
		if ($payChecked.is('[disabled]')) {
			$modal.find('[name=pay_method]:not([disabled])').prop('checked', true).trigger('change');
		}
	});
});